"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@material-ui/core/styles");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Tab = _interopRequireDefault(require("@material-ui/core/Tab"));
var _Tabs = _interopRequireDefault(require("@material-ui/core/Tabs"));
var _Menu = _interopRequireDefault(require("@material-ui/core/Menu"));
var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));
var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));
var _HighlightOff = _interopRequireDefault(require("@material-ui/icons/HighlightOff"));
var _Edit = _interopRequireDefault(require("@material-ui/icons/Edit"));
var _TabContext = _interopRequireDefault(require("@material-ui/lab/TabContext"));
var _TabPanel = _interopRequireDefault(require("@material-ui/lab/TabPanel"));
var _SttPaper = _interopRequireDefault(require("../SttSurfaces/SttPaper"));
var _SttAlerta = _interopRequireDefault(require("../SttAlerta"));
var _SttTabPanel = require("./SttTabPanel");
var _excluded = ["conteudo"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var useStyles = (0, _styles.makeStyles)({
  wrapper: {
    display: "flex",
    flexDirection: "row",
    padding: 0
  }
});
var ClosabeTabLabel = function ClosabeTabLabel(props) {
  var title = props.title,
    handleClose = props.handleClose,
    index = props.index;
  return /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    disableRipple: true,
    size: "small",
    onClick: function onClick(event) {
      event.stopPropagation();
      handleClose(title, index);
    }
  }, /*#__PURE__*/_react["default"].createElement(_HighlightOff["default"], null));
};
var EditableTabLabel = function EditableTabLabel(props) {
  var title = props.title,
    handleEdit = props.handleEdit,
    index = props.index;
  return /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    disableRipple: true,
    size: "small",
    onClick: function onClick(event) {
      event.stopPropagation();
      handleEdit(title, index);
    }
  }, /*#__PURE__*/_react["default"].createElement(_Edit["default"], null));
};
var SttTabs = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var abas = props.abas,
    className = props.className,
    abaAtiva = props.abaAtiva,
    handleChangeAbaAtiva = props.handleChangeAbaAtiva,
    errors = props.errors,
    _props$canClose = props.canClose,
    canClose = _props$canClose === void 0 ? false : _props$canClose,
    handleCloseTab = props.handleCloseTab,
    _props$canEdit = props.canEdit,
    canEdit = _props$canEdit === void 0 ? false : _props$canEdit,
    _props$exigeConfirmac = props.exigeConfirmacaoClose,
    exigeConfirmacaoClose = _props$exigeConfirmac === void 0 ? true : _props$exigeConfirmac,
    handleEditTab = props.handleEditTab,
    permanente = props.permanente,
    _props$preload = props.preload,
    preload = _props$preload === void 0 ? true : _props$preload,
    _props$contextMenu = props.contextMenu,
    contextMenu = _props$contextMenu === void 0 ? false : _props$contextMenu;
  var _React$useState = _react["default"].useState(abaAtiva || '0'),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    value = _React$useState2[0],
    setValue = _React$useState2[1];
  var _React$useState3 = _react["default"].useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    removerAba = _React$useState4[0],
    setRemoverAba = _React$useState4[1];
  var _React$useState5 = _react["default"].useState(''),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    msgRemoverAba = _React$useState6[0],
    setMsgRemoverAba = _React$useState6[1];
  var _React$useState7 = _react["default"].useState([]),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    opcoesRemoverAba = _React$useState8[0],
    setOpcoesRemoverAba = _React$useState8[1];
  var classes = useStyles();

  // Context menu para cada aba
  var _useState = (0, _react.useState)({
      mouseX: null,
      mouseY: null
    }),
    _useState2 = _slicedToArray(_useState, 2),
    menuPosition = _useState2[0],
    setMenuPosition = _useState2[1];
  var _useState3 = (0, _react.useState)([]),
    _useState4 = _slicedToArray(_useState3, 2),
    opcoesMenu = _useState4[0],
    setOpcoesMenu = _useState4[1];
  var handleChange = function handleChange(event, newValue) {
    setValue(newValue);
    if (handleChangeAbaAtiva) {
      handleChangeAbaAtiva(newValue);
    }
  };
  (0, _react.useEffect)(function () {
    if (abaAtiva) {
      setValue(abaAtiva);
    }
  }, [abaAtiva]);
  (0, _react.useEffect)(function () {
    if (abas.length === 1 || abas.length == value) {
      setValue('0');
    }
  }, [abas]);
  var preCloseTab = function preCloseTab(titulo, indice) {
    var aba = abas[indice];
    if (exigeConfirmacaoClose || aba.exigeConfirmacaoClose) {
      setMsgRemoverAba("Voc\xEA deseja realmente fechar a aba \"".concat(titulo, "\"?"));
      setRemoverAba(true);
      var opcoes = [{
        title: "Sim",
        onClick: function onClick(params) {
          handleCloseTab(params);
          setRemoverAba(false);
        },
        params: [indice]
      }, {
        title: "Não",
        onClick: function onClick() {
          return setRemoverAba(false);
        }
      }];
      setOpcoesRemoverAba(opcoes);
    } else {
      handleCloseTab([indice]);
      setRemoverAba(false);
    }
  };
  var createLabel = function createLabel(aba, indice) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", null, aba.titulo), canEdit && /*#__PURE__*/_react["default"].createElement(EditableTabLabel, {
      title: aba.titulo,
      index: indice,
      handleEdit: handleEditTab
    }), canClose && !aba.permanente && /*#__PURE__*/_react["default"].createElement(ClosabeTabLabel, {
      title: aba.titulo,
      index: indice,
      handleClose: preCloseTab
    }));
  };
  var handleContextMenu = function handleContextMenu(event, tab) {
    if (contextMenu && tab.contextMenu) {
      event.preventDefault();
      setMenuPosition({
        mouseX: event.clientX - 2,
        mouseY: event.clientY - 4
      });
      setOpcoesMenu(tab.contextMenu || []);
    }
  };
  var handleCloseMenu = function handleCloseMenu() {
    setMenuPosition({
      mouseX: null,
      mouseY: null
    });
    setOpcoesMenu([]);
  };
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      setValue: setValue,
      handleChange: handleChange
    };
  });
  return /*#__PURE__*/_react["default"].createElement(_SttPaper["default"], {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(_TabContext["default"], {
    value: value
  }, /*#__PURE__*/_react["default"].createElement(_Tabs["default"], {
    onChange: handleChange,
    value: value,
    variant: "scrollable",
    scrollButtons: "auto"
  }, abas.map(function (aba, indice) {
    return /*#__PURE__*/_react["default"].createElement(_Tab["default"], {
      component: "div",
      key: aba.key || aba.idAba || aba.id || indice,
      classes: classes,
      disabled: aba.disabled,
      label: createLabel(aba, indice),
      disableRipple: true,
      style: {
        maxWidth: '300px',
        'color': errors && (aba.key && errors[aba.key] || !aba.key && errors[indice]) ? '#F5222D' : ''
      },
      onClick: aba.handleClick || null,
      value: indice.toString(),
      onContextMenu: function onContextMenu(event) {
        return handleContextMenu(event, aba);
      }
    });
  })), abas.map(function (aba, indice) {
    var conteudo = aba.conteudo,
      other = _objectWithoutProperties(aba, _excluded);
    var Conteudo = conteudo;
    var Panel = _TabPanel["default"];
    if (permanente) {
      Panel = _SttTabPanel.SttTabPanel;
    }
    var panelValue = indice.toString();
    if (indice == value) {
      aba.carregada = true;
    }
    return /*#__PURE__*/_react["default"].createElement(Panel, {
      key: aba.key || aba.idAba || aba.id || indice,
      value: panelValue
    }, preload || aba.carregada ? /*#__PURE__*/_react["default"].createElement(Conteudo, other) : null);
  })), /*#__PURE__*/_react["default"].createElement(_SttAlerta["default"], {
    open: removerAba,
    title: "Aten\xE7\xE3o",
    message: msgRemoverAba,
    type: "alert",
    options: opcoesRemoverAba,
    onClose: function onClose() {
      return setRemoverAba(false);
    }
  }), /*#__PURE__*/_react["default"].createElement(_Menu["default"], {
    open: Boolean(menuPosition.mouseY),
    onClose: handleCloseMenu,
    anchorReference: "anchorPosition",
    anchorPosition: menuPosition.mouseY !== null && menuPosition.mouseX !== null ? {
      top: menuPosition.mouseY,
      left: menuPosition.mouseX
    } : undefined
  }, opcoesMenu.map(function (opcao) {
    return /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
      onClick: function onClick() {
        opcao.acao();
        handleCloseMenu();
      }
    }, opcao.titulo);
  })));
});
SttTabs.propTypes = {
  abas: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    titulo: _propTypes["default"].string.isRequired,
    conteudo: _propTypes["default"].elementType.isRequired,
    handleClick: _propTypes["default"].func,
    permanente: _propTypes["default"].bool
  })).isRequired,
  preload: _propTypes["default"].bool,
  canClose: _propTypes["default"].bool,
  permanente: _propTypes["default"].bool
};
var _default = SttTabs;
exports["default"] = _default;